import Resource from '@/api/resource'
import request from '@/utils/request'
import store from '@/store/index'

class Experiments extends Resource {
  constructor() {
    super('experiments')
  }

  RandExperiments(query) {
    return request({
      url: `${this.uri}/randExperiments`,
      method: 'POST',
      data: query,
    })
  }

  list(query) {
    return request({
      url: `${this.uri}/index`,
      method: 'POST',
      data: query,
    })
  }

  remove(id) {
    return request({
      url: `/${this.uri}/${id}`,
      method: 'delete',
      headers: { 'Content-Type': 'application/json' },
    })
  }

  put(query) {
    return request({
      url: `/${this.uri}/store`,
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'post',
      data: query,
      // onUploadProgress: function (progressEvent) {
      //     store.commit('app/SET_UPLOAD_PROGRESS', parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)))
      // }.bind(store),
    })
  }

  update(query) {
    return request({
      url: `/${this.uri}/update/${query.id}`,
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'post',
      data: query.query,
      //   onUploadProgress: function (progressEvent) {
      //     store.commit('app/SET_UPLOAD_PROGRESS', parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)))
      //   }.bind(store),
    })
  }

  getVersions(id) {
    return request({
      url: `/${this.uri}/${id}/versions`,
      method: 'get',
    })
  }

  get(id) {
    return request({
      url: `/${this.uri}/show/${id}`,
      method: 'get',
    })
  }

  statusLookups() {
    return request({
      url: `/${this.uri}/statusLookups`,
      method: 'get',
    })
  }

  experimentsLookups() {
    return request({
      url: `/${this.uri}/lookups`,
      method: 'get',
    })
  }

  filter(id) {
    return request({
      url: `/${this.uri}/filter/${id}`,
      method: 'post',
    })
  }

  subExperimentsLookups() {
    return request({
      url: '/lookups/types_lookups',
      method: 'get',
    })
  }

  getExpId(query) {
    return request({
      url: `/${this.uri}/getIdFromTarget`,
      method: 'post',
      data: query,
    })
  }

  order(query) {
    return request({
      url: `/${this.uri}/resorting`,
      method: 'post',
      data: query,
    })
  }

  watched(query) {
    return request({
      url: `/${this.uri}/watched`,
      method: 'post',
      data: query,
    })
  }

  getStudentProgressLog(query) {
    return request({
      url: '/experiment-sessions/index',
      method: 'post',
      data: query,
    })
  }

  toggleFeatured(id) {
    return request({
      url: `/${this.uri}/featured/${id}`,
      method: 'post',
    })
  }
}

export { Experiments as default }
